import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, Building2Icon, FileTextIcon, FacebookIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
import { NordenMascot } from './NordenMascot';
export function Footer() {
  return <footer className="bg-navy-950" data-id="element-425">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-426">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-10 lg:gap-6" data-id="element-427">
          {/* Column 1 — Brand */}
          <div className="sm:col-span-2" data-id="element-428">
            <img src="https://cdn.magicpatterns.com/uploads/fGPZ5CSfvu5NW1orNYB6mv/Logo_Noord_Hooft.svg" alt="Noord Digital" className="h-10 w-auto mb-4 brightness-0 invert" data-id="element-429" />
            <p className="text-navy-400 text-sm mb-4 max-w-xs" data-id="element-430">
              Jouw online groei, Onze expertise. Professioneel webdesign voor
              ondernemers in Noord-Holland.
            </p>
            {/* Norden as brand mascot */}
            <div className="flex items-center gap-3 mb-6" data-id="element-431">
              <div className="opacity-40" data-id="element-432">
                <NordenMascot variant="wave" size="sm" data-id="element-433" />
              </div>
              <span className="text-xs text-navy-500" data-id="element-434">
                Norden, jouw digitale gids
              </span>
            </div>
            <div className="flex items-center gap-4" data-id="element-435">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-navy-500 hover:text-white transition-colors" aria-label="Facebook" data-id="element-436">
                <FacebookIcon className="w-5 h-5" data-id="element-437" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-navy-500 hover:text-white transition-colors" aria-label="Instagram" data-id="element-438">
                <InstagramIcon className="w-5 h-5" data-id="element-439" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-navy-500 hover:text-white transition-colors" aria-label="LinkedIn" data-id="element-440">
                <LinkedinIcon className="w-5 h-5" data-id="element-441" />
              </a>
            </div>
          </div>

          {/* Column 2 — Diensten */}
          <div data-id="element-442">
            <h4 className="text-white font-semibold text-sm mb-4" data-id="element-443">Diensten</h4>
            <nav className="flex flex-col gap-3" data-id="element-444">
              <a href="#/" className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-445">
                Homepage
              </a>
              <a href="#/seo-voor-websites" className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-446">
                SEO voor websites
              </a>
              <a href="#/wordpress-websites" className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-447">
                WordPress websites
              </a>
              <a href="#/hosting-onderhoud" className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-448">
                Hosting & onderhoud
              </a>
            </nav>
          </div>

          {/* Column 3 — Kennisbank */}
          <div data-id="element-449">
            <h4 className="text-white font-semibold text-sm mb-4" data-id="element-450">
              Kennisbank
            </h4>
            <nav className="flex flex-col gap-3" data-id="element-451">
              <a href="#/kennisbank" className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-452">
                Alle artikelen
              </a>
              <a href="#/kosten-website-laten-maken" className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-453">
                Kosten website
              </a>
              <a href="#/website-laten-maken-checklist" className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-454">
                Website checklist
              </a>
              <a href="#/wordpress-vs-wix" className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-455">
                WordPress vs Wix
              </a>
              <a href="#/website-tips" className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-456">
                Website tips
              </a>
            </nav>
          </div>

          {/* Column 4 — Lokale pagina's */}
          <div data-id="element-457">
            <h4 className="text-white font-semibold text-sm mb-4" data-id="element-458">Regio</h4>
            <nav className="flex flex-col gap-3" data-id="element-459">
              <a href="#/webdesign-alkmaar" className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-460">
                Webdesign Alkmaar
              </a>
              <a href="#/webdesign-haarlem" className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-461">
                Webdesign Haarlem
              </a>
              <a href="#/webdesign-amsterdam" className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-462">
                Webdesign Amsterdam
              </a>
              <a href="#/webdesign-zaanstad" className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-463">
                Webdesign Zaanstad
              </a>
              <a href="#/webdesign-purmerend" className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-464">
                Webdesign Purmerend
              </a>
              <a href="#/webdesign-hoorn" className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-465">
                Webdesign Hoorn
              </a>
              <a href="#/webdesign-den-helder" className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-466">
                Webdesign Den Helder
              </a>
              <a href="#/webdesign-hilversum" className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-467">
                Webdesign Hilversum
              </a>
            </nav>
          </div>

          {/* Column 5 — Contact */}
          <div data-id="element-468">
            <h4 className="text-white font-semibold text-sm mb-4" data-id="element-469">Contact</h4>
            <div className="space-y-3" data-id="element-470">
              <a href="tel:+31616265214" className="flex items-center gap-3 text-sm text-navy-400 hover:text-white transition-colors" data-id="element-471">
                <PhoneIcon className="w-4 h-4 text-navy-500 flex-shrink-0" data-id="element-472" />
                +31 6 16265214
              </a>
              <a href="mailto:info@noorddigital.nl" className="flex items-center gap-3 text-sm text-navy-400 hover:text-white transition-colors" data-id="element-473">
                <MailIcon className="w-4 h-4 text-navy-500 flex-shrink-0" data-id="element-474" />
                info@noorddigital.nl
              </a>
              <div className="flex items-center gap-3 text-sm text-navy-400" data-id="element-475">
                <Building2Icon className="w-4 h-4 text-navy-500 flex-shrink-0" data-id="element-476" />
                KVK: 96071044
              </div>
              <div className="flex items-center gap-3 text-sm text-navy-400" data-id="element-477">
                <FileTextIcon className="w-4 h-4 text-navy-500 flex-shrink-0" data-id="element-478" />
                BTW: NL867457521B01
              </div>
              <div className="flex items-start gap-3 text-sm text-navy-400" data-id="element-479">
                <MapPinIcon className="w-4 h-4 text-navy-500 flex-shrink-0 mt-0.5" data-id="element-480" />
                Schuit 8a, 1724 BD Oudkarspel
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-navy-800 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-481">
          <p className="text-sm text-navy-500" data-id="element-482">
            © 2026 Noord Digital. Alle rechten voorbehouden.
          </p>
          <div className="flex items-center gap-6" data-id="element-483">
            <a href="#" className="text-sm text-navy-500 hover:text-white transition-colors" data-id="element-484">
              Privacy
            </a>
            <a href="#" className="text-sm text-navy-500 hover:text-white transition-colors" data-id="element-485">
              Voorwaarden
            </a>
          </div>
        </div>
      </div>
    </footer>;
}